<app-scrollable-dialog headerKey="context.selectCompany">
  <div content>
    <app-select-input
      [label]="'context.selectCompany' | locCap"
      [formControl]="companyControl"
      [options]="companySelect"
    ></app-select-input>
    <span>{{ 'context.selectCompanyTT' | loc }}</span>
  </div>
  <div actions>
    <button mat-stroked-button [mat-dialog-close]="false" color="primary">
      {{ 'button.cancel' | locCap }}
    </button>
    <button mat-raised-button (click)="submit()" color="primary">
      {{ 'button.confirm' | locCap }}
    </button>
  </div>
</app-scrollable-dialog>
